import { decodeAuthToken } from './decodeAuthToken';

export const getFullNameByAuthToken = (authToken: string) => {
    const profile = decodeAuthToken(authToken);

    if (profile) {
        const { firstName, lastName } = profile;

        return `${firstName} ${lastName}`;
    }

    return '';
};
